var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCritical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    width: 250,
    height: 250,
    viewBox: "0 0 244.14063 173.14453",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#D3C9BA;}\n\t.st1{fill:#379ED2;}\n")), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 122.07031,13.330076 c -40.439867,0 -73.242184,32.802317 -73.242184,73.242188 0,40.439876 32.802317,73.242196 73.242184,73.242196 40.43988,0 73.2422,-32.80232 73.2422,-73.242196 0,-40.439871 -32.80232,-73.242188 -73.2422,-73.242188 z M 98.570149,127.01214 H 85.938807 c -4.993786,0 -9.008398,-4.01461 -9.008398,-9.0084 0,-4.99378 4.014612,-9.0084 9.008398,-9.0084 H 98.570149 Z M 93.184692,81.382644 c -5.679207,0 -10.281324,-4.602116 -10.281324,-10.281324 0,-5.679207 4.602117,-10.281323 10.281324,-10.281323 5.679209,0 10.281318,4.602116 10.281318,10.281323 0,5.679208 -4.602109,10.281324 -10.281318,10.281324 z M 119.03488,127.01214 H 103.9556 v -18.11471 h 15.07928 z m 21.15015,0 h -15.66678 v -18.11471 h 15.66678 z m 0.39167,-55.91082 c 0,-5.679207 4.60211,-10.281323 10.28132,-10.281323 5.67921,0 10.28133,4.602116 10.28133,10.281323 0,5.679208 -4.60212,10.281324 -10.28133,10.281324 -5.58129,0 -10.28132,-4.602116 -10.28132,-10.281324 z m 17.52721,55.91082 h -12.53343 v -18.11471 h 12.53343 c 4.99378,0 9.0084,4.01461 9.0084,9.00839 0.0979,5.09171 -4.01462,9.10632 -9.0084,9.10632 z",
    id: "path4",
    style: {
      strokeWidth: 0.979174
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 227.69825,51.516013 c 0,15.7 -12.69996,28.400004 -28.39991,28.400004 -15.69994,0 -28.3999,-12.700004 -28.3999,-28.400004 0,-15.7 28.3999,-62.6 28.3999,-62.6 0,0 28.39991,46.9 28.39991,62.6 z",
    id: "path6",
    style: {
      fill: "#379ed2",
      strokeWidth: 0.999998
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "critical.18d559855204e1bf2a6db8c630934583.svg";
export { ForwardRef as ReactComponent };